export default __webpack_public_path__ + "static/media/SixEasyPieces.78e9a17b.png";